// extracted by mini-css-extract-plugin
export default {"Light":"Light_Light__u+wy5","on":"Light_on__EETz2","off":"Light_off__AzroN"};